/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

// import Vue from 'vue';
// import store from '@/store';
// import * as types from './mutation-types';
/*
import API from '@/api/';
export const fetchPlanList = ({
  commit
}) => {
  return new Promise((resolve) => {
    API.plan.fetchPlanList().then(res => {
      if (res.status === 200) {
        commit(`plan/SET_PLANLIST`, {
          items: res.data
        }, {
          root: true
        })
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }
    })
  });
};
*/
import API from '@/api/'

export const list = ({ commit },params) => {
  return new Promise((resolve) => {
    API.category.list(params).then(res => {
      if (res.status === 200) {
        commit(`category/SET_LIST`, res.data, {
          root: true
        });
        /*
        commit(`category/SET_TOTAL`, res.data.total, {
          root: true
        });
        commit(`category/SET_OFFSET`, res.data.offset, {
          root: true
        });
        commit(`category/SET_MAX`, res.data.max, {
          root: true
        });
        */
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const add = ({ commit },params) => {
  return new Promise((resolve) => {
    API.category.add(params).then(res => {
      if (res.status === 201) {
        commit(`category/APPEND`, res.data, {
          root: true
        });
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const update = ({ commit },params) => {
  return new Promise((resolve) => {
    API.category.update(params).then(res => {
      if (res.status === 200) {
        commit(`category/UPDATE`, res.data, {
          root: true
        });
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const remove = ({ commit },params) => {
  return new Promise((resolve) => {
    API.category.remove(params).then(res => {
      if (res.status === 200) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const clear = ({ commit }) => {
  return new Promise((resolve) => {
    commit(`category/CLEAR`, {
      root: true
    });
    resolve();
  })
}
export default {
  list,
  add,
  update,
  remove,
  clear
};